import MainLayout from "Layout/MainLayout";
import React from "react";
import HeaderListDesa from "Layout/HeaderListDesa";
import RegisteredCounter from "Layout/RegisteredCounter";
import Joined from "Layout/Joined";
import Review from "Layout/Review";

export default function DaftarDesa() {
  return (
    <MainLayout active="listdesa">
      <HeaderListDesa />
      <RegisteredCounter />
      <Joined />
      <Review />
    </MainLayout>
  );
}
